var m;
((a) => {
  function o(n) {
    return Object.entries(n).map(([r, e]) => `${encodeURIComponent(r)}=${encodeURIComponent(e)}`).join("&");
  }
  a.encodeParams = o;
  function t(n) {
    return Array.from(n.searchParams.entries()).reduce((r, e) => ({ ...r, [e[0]]: e[1] }), {});
  }
  a.getParamsFromUrl = t;
  function c(n, r) {
    const e = new URL(n.toString()), i = t(e), u = o({
      ...i,
      ...r
    });
    return e.search = u, e.toString();
  }
  a.replaceParameters = c;
  function s(n = "") {
    const r = new URL(window.location.toString()), { searchParams: e } = r;
    e.delete(n), window.history.pushState({}, "", r);
  }
  a.removeParamFromUrl = s;
})(m || (m = {}));
export {
  m as UrlsAPI
};
//# sourceMappingURL=index.js.map
